import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { gOCategorySettingForm } from '../model/form';
import { UserFeedbackService } from '../user-feedback.service';
import { NetworkConstants, removeUndefined } from 'diwimamodelweb';
import { SettingsService } from '../settings.service';
import { firstValueFrom, skipWhile, take } from 'rxjs';

@Component({
  selector: 'app-geo-object-category-form',
  templateUrl: './geo-object-category-form.component.html',
  styleUrls: ['./geo-object-category-form.component.css', '../../app.component.scss']
})
export class GeoObjectCategoryFormComponent implements OnInit {

  @Input() data: gOCategorySettingForm
  @Input() formBuilder: FormBuilder
  @Input() translateService: TranslateService
  
  geoObjectCategoryForm: FormGroup
  isCreate = false
  allCategoriesNumber
  deleteRight = false
  updateRight = false
  
  constructor(
    private userFeedbackService: UserFeedbackService,
    private settingsService: SettingsService
  ) { }

  async ngOnInit(): Promise<void> {
    const context = await firstValueFrom(this.settingsService.selectedUserContext$.pipe(
      skipWhile(el => !el),
      take(1)
    ))
    const rights = this.settingsService.rightsPercontext.get(context.identifier)
    this.updateRight = !rights?.[NetworkConstants.ROUTE_CTX_SETTINGS]?.['U'] ?? false
    this.deleteRight = !rights?.[NetworkConstants.ROUTE_CTX_SETTINGS]?.['D'] ?? false

    this.allCategoriesNumber = this.settingsService.settingPoiCategory?.value?.values?.length
    
    this.geoObjectCategoryForm = this.formBuilder.group({
      title: [, Validators.required],
      identifier: [],
      sortIndex: [],
      titles:[]
    })

    if (!this.data.data) {
      this.isCreate = true
      this.geoObjectCategoryForm.patchValue({ sortIndex: this.allCategoriesNumber})
    }
   
    if(this.data.data) {
      this.initializeWithData()
    }
  }

  initializeWithData() {
    const {title, sortIndex, titles, identifier} = this.data.data
    
    this.geoObjectCategoryForm.patchValue({
      title: title ? title : undefined, 
      identifier: identifier ? identifier : undefined, 
      sortIndex: sortIndex ? sortIndex : undefined,
      titles : titles ? titles : undefined
    })

  }


  onSubmit() {
    const {title, sortIndex, titles, identifier} = this.geoObjectCategoryForm.value 

    if (this.isCreate) {
      let setting: any = {
        title,
        identifier: identifier ?? title,
        sortIndex: sortIndex ?? this.allCategoriesNumber,
        titles: titles ?? {}
      }
      const cleaned = removeUndefined(setting)
      this.data.onCreate(cleaned)
    } else {
      this.data.data.title = title
      // this.data.data.identifier = identifier ?? title
      this.data.onSubmit()
    }
  }
  onDelete(){
    this.data.onDelete(this.data)
  }

}
